/**
 * 帮助图片文案配置
 * key: 图片文件名（不含扩展名，如 "step-1"）
 * value: { desc: "支持 HTML，可写 <a> 标签实现可点击链接" }
 *
 * 修改文案只需编辑此文件，无需动 vue 组件
 *
 * 示例：
 *   "step-1": { desc: "第一步: <a href='https://cloud.tencent.com/login' target='_blank'>登陆腾讯云</a>，点击控制台" },
 */
export default {
  "step-1": { desc: "第一步: <a href='https://cloud.tencent.com/login' target='_blank'>登陆腾讯云</a>，点击控制台" },
  "step-2": { desc: "第二步: 顶部搜索框搜索 ‘ 云点播 ’ " },
  "step-3": { desc: "第三步: 左侧先点击应用管理，在点击右侧主应用的进入应用 " },
  "step-4": { desc: "第四步: 点击 ‘上传视频’ " },
  "step-5": { desc: "第五步: 先选择文件,在点击 ‘ 上传后自动进行视频处理 ’ , 点击 ‘ 模版选择 ’，选择常用模版，完成后点击 ‘ 开始上传 ’，等待上传状态变成上传成功后，点击左上角的 ‘ 已上传 ’", },
  "step-6": { desc: "第六步: 将鼠标移入对应的视频，点击 ‘ 快速查看 ’，在右侧弹窗中复制源码链接和解码链接 " },
  "step-7": { desc: "第七步: 将复制的源码链接和解码链接填入上传视频对应的输入框，填写其他信息后，点击上传视频"},
}
